/** 
 * @module imports/errorHandling 
 * @requires module:imports/history
 */
import { toast } from 'react-toastify';
import history from './history';
import * as auth from './auth';
import * as axios from 'axios';


/**
 * toast a error message or maybe redirect to a page by classification errors
 * @param  {Object | Error} error error object or instance of Error
 */
const ajaxErrorHandling = (error) => {
    if (error.response) {
        const splitedArray = error.request.responseURL.split('/')
        switch (error.response.status) {
            case 400:
                if (splitedArray[splitedArray.length - 1] === 'user_projects') {
                    break;
                }
                toast.error('اشتباه در داده‌ی ورودی!');
                break;
            case 500:
                toast.error('خطا در سرور (500)!');
                break;
            case 404:
                if (splitedArray[splitedArray.length - 1] === 'submit' && splitedArray[splitedArray.length - 2] === 'voucher') {
                    toast.error(error.response.data.detail);                    
                    break;
                }
                toast.error('هیچ مسیری برای این درخواست یافت نشد )404(!');
                break;
            case 401: 
                auth.logout();
                if (history.action === "POP") {
                    history.goBack();
                } else if (splitedArray[splitedArray.length - 1] === 'enrollment') {
                    history.push(`/login?go=/enrollment/${splitedArray[splitedArray.length - 2]}`);
                } else {
                toast.error('نیاز به دسترسی کاربری وجود دارد.');
                    history.push('/login');
                }
                break;
            case 403: 
                if (splitedArray[splitedArray.length - 1] === 'posts') {
                    toast.error(error.response.data.detail);                    
                    break;
                }
                toast.error('شما دسترسی به این بخش را ندارید.');
                history.goBack();
                break;
            case 406:
                // toast.error('در انتظار تایید ثبت نام شما.');
                toast.error(error.response.data.detail);
                break;
            case 409:
                if (splitedArray[splitedArray.length - 1] === 'submit' && splitedArray[splitedArray.length - 2] === 'voucher') {
                    toast.error(error.response.data.detail);                    
                    break;
                }
                toast.warning(error.response.data.detail);
                history.replace('/my-programs');
                break;
            case 423:
                if (splitedArray[splitedArray.length - 1] === 'submit' && splitedArray[splitedArray.length - 2] === 'voucher') {
                    toast.error(error.response.data.detail);                    
                    break;
                }
                if (splitedArray[splitedArray.length - 2] === 'program') {
                    toast.error('امکان دسترسی به این قسمت در حال حاضر وجود ندارد.');                                   
                    break;
                }
                toast.error('امکان دسترسی به این قسمت در حال حاضر وجود ندارد.');
                history.goBack();
                break;
            case 402:
                toast.error('اعتباری جهت دسترسی به این قسمت دریافت نشده.');
                history.goBack();
                break;
            case 429:
                toast.error(error.response.data.detail);
                break;
            case 422:
                toast.error(error.response.data.detail);
                break;
            case 413:
                toast.error(error.response.data.detail);
                break;
            default:
                toast.error('خطای ناشناخته!');
        }
    } else if (error.request) {
        toast.error('خطا در برقراری ارتباط با سرور!');
    } else {
        if (axios.isCancel(error)) {
            toast.warn(error.message)
        } else {
            toast.error('خطا در سیستم!');
            console.error(error.message);
        }
    }
}

export {
    ajaxErrorHandling,
}